export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12164.c17b417e.jpg";